import React from 'react'
import {Icon} from '@chakra-ui/react'

const AddIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="add-icon" {...props} aria-hidden="true">
            <path
                d="M20.46 32.92C19.91 32.92 19.46 32.47 19.46 31.92V9C19.46 8.45 19.91 8 20.46 8C21.01 8 21.46 8.45 21.46 9V31.92C21.46 32.47 21.01 32.92 20.46 32.92Z"
                fill="currentColor"
            />
            <path
                d="M31.92 21.46H9C8.45 21.46 8 21.01 8 20.46C8 19.91 8.45 19.46 9 19.46H31.92C32.47 19.46 32.92 19.91 32.92 20.46C32.92 21.01 32.47 21.46 31.92 21.46Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default AddIcon
